import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import logokpru from "../assets/logokpru.png";
import "./Headers.css";

class Headers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: localStorage.getItem("name") || "",
      menuOpen: false,
      openGroups: {},
    };
    this.handleLogout = this.handleLogout.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.toggleGroup = this.toggleGroup.bind(this);
  }

  getNavConfig() {
    const status = localStorage.getItem("checkstatus");
    const shortname = localStorage.getItem("shortname");

    if (status === "student") {
      return {
        home: "/Datarubrong",
        role: "นักศึกษา",
        items: [
          { to: "/Addpetition", label: "ยื่นคำร้อง", icon: "fa-plus" },
          { to: "/Datarubrong", label: "สถานะคำร้อง", icon: "fa-file-alt" },
        ],
      };
    }

    if (status === "tabian" && shortname !== "ผดุงพร") {
      return {
        home: "/Showcertificate",
        role: "งานทะเบียน",
        items: [
          {
            label: "คำร้อง",
            icon: "fa-folder-open",
            children: [
              { to: "/Showcertificate", label: "สถานะคำร้อง", icon: "fa-file-alt" },
              { to: "/Showcertificatehistory", label: "ประวัติคำร้อง", icon: "fa-history" },
              { to: "/Showreason", label: "เหตุผลประกอบ", icon: "fa-comment-alt" },
            ],
          },
          { to: "/AddNumberRubrong", label: "เลขที่หนังสือครูคืนถิ่น", icon: "fa-file-medical" },
          { to: "/ShowSJCODERubrong", label: "รายวิชาที่รับรอง", icon: "fa-book" },
          { to: "/AddDateJob", label: "วันจบการศึกษา", icon: "fa-calendar-alt" },
        ],
      };
    }

    if (shortname === "ผดุงพร") {
      return {
        home: "/ShowcertificateHeadtabian",
        role: "นายทะเบียน",
        items: [
          { to: "/ShowcertificateHeadtabian", label: "สถานะคำร้อง", icon: "fa-file-alt" },
          { to: "/ShowcertificateHeadtabianhistory", label: "ประวัติคำร้อง", icon: "fa-history" },
        ],
      };
    }

    if (status === "teacher") {
      if (shortname === "วิสิฐ") {
        return { home: "/ShowcertificateTeacher", role: "อาจารย์", items: [] };
      }
      if (shortname === "จิรพงค์") {
        return {
          home: "/ShowcertificateHeadtabian",
          role: "อาจารย์",
          items: [
            { to: "/ShowcertificateHeadtabian", label: "สถานะคำร้อง", icon: "fa-file-alt" },
            { to: "/ShowcertificateHeadtabianhistory", label: "ประวัติคำร้อง", icon: "fa-history" },
          ],
        };
      }
      if (shortname === "ฆัมภิชา") {
        return {
          home: "/ShowcertificateVicerector",
          role: "รองอธิการบดี",
          items: [{ to: "/ShowcertificateVicerector", label: "สถานะคำร้อง", icon: "fa-file-alt" }],
        };
      }
      return {
        home: "/ShowcertificateTeacher",
        role: "อาจารย์",
        items: [{ to: "/ShowcertificateTeacher", label: "สถานะคำร้อง", icon: "fa-file-alt" }],
      };
    }

    return { home: "/", role: "", items: [] };
  }

  isActive(path) {
    return this.props.location.pathname === path;
  }

  isGroupOpen(item) {
    return !!this.state.openGroups[item.label];
  }

  toggleGroup(item) {
    this.setState((prev) => ({
      openGroups: {
        ...prev.openGroups,
        [item.label]: !prev.openGroups[item.label],
      },
    }));
  }

  toggleMenu() {
    this.setState((prev) => ({ menuOpen: !prev.menuOpen }));
  }

  closeMenu() {
    this.setState({ menuOpen: false });
  }

  handleLogout(event) {
    event.preventDefault();
    localStorage.clear();
    window.location.href = "/rubrongkpru/";
  }

  renderNavItem(item) {
    if (item.children) {
      const open = this.isGroupOpen(item);
      const childActive = item.children.some((child) => this.isActive(child.to));
      return (
        <li key={item.label} className={`app-sidebar-group${open ? " open" : ""}`}>
          <button
            type="button"
            className={`app-sidebar-group-title${childActive ? " active" : ""}`}
            onClick={() => this.toggleGroup(item)}
            aria-expanded={open}
          >
            <i className={`fas ${item.icon}`} aria-hidden="true" />
            <span>{item.label}</span>
            <i className="fas fa-chevron-down app-sidebar-caret" aria-hidden="true" />
          </button>
          {open ? (
            <ul className="app-sidebar-sub">
              {item.children.map((child) => (
                <li key={child.to}>
                  <Link
                    to={child.to}
                    className={`app-sidebar-link${this.isActive(child.to) ? " active" : ""}`}
                    onClick={this.closeMenu}
                  >
                    <i className={`fas ${child.icon || "fa-angle-right"}`} aria-hidden="true" />
                    {child.label}
                  </Link>
                </li>
              ))}
            </ul>
          ) : null}
        </li>
      );
    }

    return (
      <li key={item.to}>
        <Link
          to={item.to}
          className={`app-sidebar-link${this.isActive(item.to) ? " active" : ""}`}
          onClick={this.closeMenu}
        >
          <i className={`fas ${item.icon}`} aria-hidden="true" />
          {item.label}
        </Link>
      </li>
    );
  }

  render() {
    const nav = this.getNavConfig();

    return (
      <>
        {this.state.menuOpen ? (
          <button type="button" className="app-sidebar-backdrop" onClick={this.closeMenu} aria-label="ปิดเมนู" />
        ) : null}

        <aside className={`app-sidebar${this.state.menuOpen ? " open" : ""}`}>
          <Link to={nav.home} className="app-sidebar-brand" onClick={this.closeMenu}>
            <img className="app-sidebar-logo" src={logokpru} alt="KPRU" />
            <span className="app-sidebar-title">
              <strong>ระบบขอเอกสารทางการศึกษา</strong>
              <small>มหาวิทยาลัยราชภัฏกำแพงเพชร</small>
            </span>
          </Link>

          <nav className="app-sidebar-nav">
            <div className="app-sidebar-label">เมนูหลัก</div>
            <ul className="app-sidebar-list">{nav.items.map((item) => this.renderNavItem(item))}</ul>
          </nav>
        </aside>

        <header className="app-topbar">
          <button type="button" className="app-topbar-toggle" onClick={this.toggleMenu} aria-label="เปิดเมนู">
            <i className={`fas ${this.state.menuOpen ? "fa-times" : "fa-bars"}`} />
          </button>
          <div className="app-topbar-user">
            <div className="app-topbar-user-meta">
              <span className="app-topbar-user-name">{this.state.name}</span>
              {nav.role ? <span className="app-topbar-user-role">{nav.role}</span> : null}
            </div>
            <button type="button" className="app-topbar-logout" onClick={this.handleLogout}>
              ออกจากระบบ
            </button>
          </div>
        </header>
      </>
    );
  }
}

export default withRouter(Headers);
